import React from "react";
import { useTranslation } from "react-i18next";
import { Logo_SY } from "@assets/icons";
import { styled, SxProps, Theme } from "@mui/material";

const ImgElement = styled("img")({});
const getImgSx = (big: boolean) => (theme: Theme) => ({
  width: theme.spacing(big ? 20 : 10),
  height: theme.spacing(big ? 20 : 10),
});

const LogoImg = ({
  big = false,
  sx,
}: {
  big?: boolean;
  sx?: SxProps<Theme>;
}) => {
  const { t } = useTranslation();
  const alt = t("symphony logo");
  return (
    <ImgElement
      src={Logo_SY}
      alt={alt}
      sx={[...(Array.isArray(sx) ? sx : [sx]), getImgSx(big)]}
    />
  );
};

export default LogoImg;
